import { Injectable } from '@angular/core';
import { AnagraficaDto, DatiParteA, DatiParteB } from "../model/model";
import { AssignComuniService } from './assign-comuni.service';

@Injectable({
  providedIn: 'root'
})
export class RandomDataService {

  constructor(private assignComuniService: AssignComuniService) { }

  generateRandomAnagraficaDto(): AnagraficaDto {
    return {
      sesso: this.getRandomSesso(),
      cognome: this.getRandomString(),
      nome: this.getRandomString(),
      codiceFiscale: this.getRandomCodiceFiscale(),
      etaCompiuta: this.getRandomInt(100),
      fkIdFlusso: this.getRandomInt(),
    };
  }
  

  generateRandomDatiParteA(): DatiParteA {
    return {
      fkLuogoDecesso: this.getRandomString(1),
      luogoDecessoAltro: this.getRandomString(1),
      fkComuneDecesso: this.getRandomString(1),
      codiceAslDecesso: this.getRandomString(1),
      riscontroDiagnostico: this.getRandomString(1),
      causaInizialeDecesso: this.getRandomString(1),
      causaInizialeDecesso2: this.getRandomString(1),
      fkStatoGravidanza: this.getRandomString(1),
      causaDiMorte1Cod: this.getRandomString(7),
      causaDiMorte2Cod: this.getRandomString(7),
      causaDiMorte3Cod: this.getRandomString(7),
      causaDiMorte4Cod: this.getRandomString(7),
      causaDiMorte1: this.getRandomString(1),
      causaDiMorte1Anni: this.getRandomInt(5),
      causaDiMorte1Mesi: this.getRandomInt(5),
      causaDiMorte1Giorni: this.getRandomInt(5),
      causaDiMorte2: this.getRandomString(1),
      causaDiMorte2Anni: this.getRandomInt(5),
      causaDiMorte2Mesi: this.getRandomInt(5),
      causaDiMorte2Giorni: this.getRandomInt(5),
      causaDiMorte3: this.getRandomString(1),
      causaDiMorte3Anni: this.getRandomInt(5),
      causaDiMorte3Mesi: this.getRandomInt(5),
      causaDiMorte3Giorni: this.getRandomInt(5),
      causaDiMorte4: this.getRandomString(1),
      causaDiMorte4Anni: this.getRandomInt(5),
      causaDiMorte4Mesi: this.getRandomInt(5),
      causaDiMorte4Giorni: this.getRandomInt(5),
      statiMorbosi1: this.getRandomString(1),
      statiMorbosi1Anni: this.getRandomInt(5),
      statiMorbosi1Mesi: this.getRandomInt(5),
      statiMorbosi1Giorni: this.getRandomInt(5),
      statiMorbosi2: this.getRandomString(1),
      statiMorbosi2Anni: this.getRandomInt(5),
      statiMorbosi2Mesi: this.getRandomInt(5),
      statiMorbosi2Giorni: this.getRandomInt(5),
      statiMorbosi3: this.getRandomString(1),
      statiMorbosi3Anni: this.getRandomInt(5),
      statiMorbosi3Mesi: this.getRandomInt(5),
      statiMorbosi3Giorni: this.getRandomInt(5),
      eventoTraumatismo: this.getRandomString(1),
      eventoOrigineTraumatismo: this.getRandomString(1),
      fkModalitaTraumatismo: this.getRandomString(1),
      traumatismoSulLavoro: this.getRandomString(1),
      incidenteTrasportoMezzo: this.getRandomString(1),
      fkIncidenteTrasportoRuolo: this.getRandomString(1),
      incidenteTrasportoTipo: this.getRandomString(1),
      incidenteTrasportoScontro: this.getRandomString(1),
      orarioEventoHh: this.getRandomString(1),
      orarioEventoMm: this.getRandomString(1),
      giornoEvento: this.getRandomString(1),
      meseEvento: this.getRandomString(1),
      annoEvento: this.getRandomString(1),
      fkLuogoEvento: this.getRandomString(1),
      luogoEventoAltro: this.getRandomString(1),
      dataCompilazione: new Date(),
      fkTipoMedico: this.getRandomString(1),
      telefonoRiferimento: this.getRandomString(1),
      nomeCognomeMedico: this.getRandomString(1),
      validazione: false,
      validazioneData: new Date(),
      riaperturaData: new Date(),
    };
  }

  generateRandomDatiParteB(): DatiParteB {
    return {
      sesso: this.getRandomSesso(),
      attoMorteNumero: this.getRandomInt(5),
      parte1: this.getRandomString(1),
      parte2: this.getRandomString(1),
      serie1: this.getRandomString(1),
      serie2: this.getRandomString(1),
      circoscrizione: this.getRandomString(1),
      fkComune: this.getRandomString(1),
      dataMorteHh: this.getRandomString(1),
      dataMorteMm: this.getRandomString(1),
      giornoDataMorte: this.getRandomString(1),
      meseDataMorte: this.getRandomString(1),
      annoDataMorte: this.getRandomString(1),
      giornoNascita: this.getRandomString(1),
      meseNascita: this.getRandomString(1),
      annoNascita: this.getRandomString(1),
      fkLocalitaNascita: this.getRandomString(1),
      fkLocalitaComuneNascita: this.getRandomString(1),
      fkLocalitaStatoEsteroNascita: this.getRandomInt(5),
      etaCompiuta: this.getRandomInt(100),
      fkStatoCivile: this.getRandomString(1),
      annoNascitaConiuge: this.getRandomInt(2024),
      annoMatrimonioUnione: this.getRandomInt(1),
      fkLocalitaResidenza: this.getRandomString(1),
      fkComuneResidenza: this.getRandomString(1),
      fkStatoResidenza: this.getRandomInt(9),
      fkGradoIstruzione: this.getRandomString(1),
      professione: this.getRandomString(1),
      fkCondizioneProfessionale: this.getRandomString(1),
      fkPosizioneProfessione: this.getRandomString(1),
      fkRamoAttivitaEconomica: this.getRandomString(1),
      fkCittadinanza: this.getRandomString(1),
      fkCittadinanzaStatoStraniera: this.getRandomInt(9),
      recapito: this.getRandomString(1),
      telefono: this.getRandomString(1),
      email: this.getRandomString(1),
      validazione: false,
      validazioneData: new Date(),
      riaperturaData: new Date(),
    };
  }

  getRandomInt(max: number = 10000): number {
    return Math.floor(Math.random() * max);
  }

  private getRandomSesso(): string {
    return Math.random() < 0.5 ? 'M' : 'F';
  }

  getRandomString(length: number = 10): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }


  private getRandomCodiceFiscale(): string {
    return this.getRandomString(16); // CF has a fixed length of 16 chars
  }

  // Aggiungere altre funzioni helper per la generazione di dati casuali secondo necessità
}
